import axios from 'axios';
import { User } from '../models/user.models';
import { BaseService } from './base.service';

export default class TrainingLibraryService extends BaseService {
  public async getTrainingLibrary(teamId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    const url = `${this.backendUrl}/team/${teamId}/training-library`;

    return axios.get(url, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async createTrainingTemplate(teamId: string, payload: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    const url = `${this.backendUrl}/team/${teamId}/training-library`;

    return axios.post(url, payload, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async getTrainingTemplate(teamId: string, templateId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    const url = `${this.backendUrl}/team/${teamId}/training-template/${templateId}`;

    return axios.get(url, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async updateTrainingTemplate(teamId: string, templateId: string, payload: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    const url = `${this.backendUrl}/team/${teamId}/training-template/${templateId}`;

    return axios.patch(url, payload, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }

  public async deleteTrainingTemplate(teamId: string, templateId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    const url = `${this.backendUrl}/team/${teamId}/training-template/${templateId}`;

    return axios.delete(url, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async createWeeklyTrainingPlan(teamId: string, payload: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const url = `${this.backendUrl}/team/${teamId}/weekly-training-plan`;
    return axios.post(url, payload, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async getWeeklyTrainingPlans(teamId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const url = `${this.backendUrl}/team/${teamId}/weekly-training-plan`;
    return axios.get(url, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async getWeeklyTrainingPlan(teamId: string, planId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const url = `${this.backendUrl}/team/${teamId}/weekly-training-plan/${planId}`;
    return axios.get(url, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async updateWeeklyTrainingPlan(teamId: string, planId: string, payload: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const url = `${this.backendUrl}/team/${teamId}/weekly-training-plan/${planId}`;
    return axios.put(url, payload, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async deleteWeeklyTrainingPlan(teamId: string, planId: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const url = `${this.backendUrl}/team/${teamId}/weekly-training-plan/${planId}`;
    return axios.delete(url, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async loadWeeklyTrainingPlan(teamId: string, planId: string, payload: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    const url = `${this.backendUrl}/team/${teamId}/weekly-training-plan/${planId}`;
    return axios.post(url, payload, {
      headers: {
        'x-access-token': user.token,
        'Measurement-System': user.measurementSystem,
      },
    });
  }
}
